module.exports = __webpack_public_path__ + "static/img/default3-4.5f3cc16a.png";